"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outputCache = exports.getCacheKey = exports.withMobile = exports.cacheKeyWithTheme = exports.cacheKeyWithCertainQueries = exports.cacheKeyWithCookie = exports.cacheKeyWithLocation = exports.DEFAULT_REGION = exports.withCache = exports.apiCache = exports.del = exports.set = exports.get = exports.keys = exports.stringify = exports.cache = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const pick_1 = __importDefault(require("lodash/pick"));
const node_cache_1 = __importDefault(require("node-cache"));
const TTL = 10 * 60;
exports.cache = new node_cache_1.default({
    stdTTL: TTL,
    checkperiod: 60,
    useClones: false,
});
/**
 * Make key by data
 * @example
 * ```ts
 * const key = stringify({ foo: 'bar', bar: 'foo' })
 * ```
 * @param data Data
 */
const stringify = (data) => {
    if (Array.isArray(data)) {
        // join arrays values
        return `[${data.reduce((output, item) => `${output}${(0, exports.stringify)(item)}`, '')}]`;
    }
    if ((0, isObject_1.default)(data)) {
        // join object key->values
        // @ts-ignore
        return `{${Object.keys(data).reduce((output, key) => `${output}${key}=${(0, exports.stringify)(data[key])}`, '')}}`;
    }
    // all others join
    return `${data}-`;
};
exports.stringify = stringify;
const keys = () => {
    return exports.cache.keys();
};
exports.keys = keys;
/**
 * Get the value of a key
 * @example
 * ```ts
 * const data = get('entity-key')
 * ```
 * @param key Key
 */
const get = (key) => {
    const entry = exports.cache.get(key);
    if (entry) {
        // hit.inc();
        return entry;
    }
    // miss.inc();
    return undefined;
};
exports.get = get;
/**
 * Set the value of a key
 * @example
 * ```ts
 * set('entity-key', data, 60 * 1000)
 * ```
 * @param key Key
 * @param value Data
 * @param ttl Time to live
 */
const set = (key, value, ttl = TTL) => {
    exports.cache.set(key, value, ttl);
};
exports.set = set;
/**
 * Delete a key
 * @example
 * ```ts
 * del('entity-key')
 * ```
 * @param key Key
 */
const del = (key) => {
    exports.cache.del(key);
};
exports.del = del;
const apiCache = (getCacheKey, options) => {
    return async (ctx, next) => {
        const key = getCacheKey(ctx);
        if (exports.cache.has(key)) {
            ctx.response.status = 200;
            return (ctx.response.body = exports.cache.get(key));
        }
        await next();
        const value = ctx.response.body;
        if (ctx.response.status !== 200 || !value)
            return;
        exports.cache.set(key, value, (options === null || options === void 0 ? void 0 : options.ttl) || TTL);
        return;
    };
};
exports.apiCache = apiCache;
const withCache = (fn, { fnKey = fn.name, ttl = TTL, unicKeyByArgsFunc }) => {
    return async (...args) => {
        const key = unicKeyByArgsFunc ? unicKeyByArgsFunc(...args) : `${fnKey}-${(0, exports.stringify)(args)}`;
        const entry = (0, exports.get)(key);
        if (entry) {
            return entry;
        }
        const value = await fn(...args);
        (0, exports.set)(key, value, ttl);
        return value;
    };
};
exports.withCache = withCache;
const IMAGE_VERSION = process.env.IMAGE_VERSION;
const DEV = process.env.NODE_ENV === 'development';
const DEBUG_CACHE = process.env.DEBUG_CACHE === 'true';
const METHODS = {
    HEAD: true,
    GET: true,
};
exports.DEFAULT_REGION = {
    id: 83,
    name: 'Москва',
    nameLocative: 'в Москве',
    route: '6.83.',
    alias: 'moskva',
    latitude: 55.753676,
    longitude: 37.619899,
    localityType: '',
    shortLocationType: '',
};
const cacheKeyWithLocation = (ctx) => {
    const location = ctx.req.__SELECTED_LOCATION__ || exports.DEFAULT_REGION;
    return (0, exports.stringify)({ location: location.route });
};
exports.cacheKeyWithLocation = cacheKeyWithLocation;
const cacheKeyWithCookie = (cookieKeys) => (ctx) => {
    const params = cookieKeys.reduce((acc, key) => {
        if (ctx.cookies.get(key)) {
            // @ts-ignore
            acc[key] = ctx.cookies.get(key);
        }
        return acc;
    }, {});
    return (0, exports.stringify)(params);
};
exports.cacheKeyWithCookie = cacheKeyWithCookie;
const cacheKeyWithCertainQueries = (queries) => (ctx) => {
    const params = Object.assign({}, (ctx.query && !(0, isEmpty_1.default)(ctx.query) && { query: (0, pick_1.default)(ctx.query, queries) }));
    return (0, exports.stringify)(params);
};
exports.cacheKeyWithCertainQueries = cacheKeyWithCertainQueries;
const cacheKeyWithTheme = (ctx) => {
    const params = { theme: ctx.req.__THEME__ };
    return (0, exports.stringify)(params);
};
exports.cacheKeyWithTheme = cacheKeyWithTheme;
/** @deprecated withMobile includes in getCacheKey */
const withMobile = (ctx) => {
    const params = ctx.deviceInfo;
    return (0, exports.stringify)(params);
};
exports.withMobile = withMobile;
const getCacheKey = (ctx, ...compose) => {
    const url = ctx.path;
    const params = {
        url,
        version: IMAGE_VERSION,
        media: ctx.deviceInfo,
    };
    let key = `html-cache-${(0, exports.stringify)(params)}`;
    if (compose === null || compose === void 0 ? void 0 : compose.length) {
        key = compose.reduce((acc, func) => {
            return `${acc}-${func(ctx)}`;
        }, key);
    }
    return key;
};
exports.getCacheKey = getCacheKey;
const outputCache = (ttl = TTL, options = {}) => {
    return async (ctx, next) => {
        // @ts-ignore
        if (!METHODS[ctx.request.method] || (DEV && !DEBUG_CACHE) || !(0, isEmpty_1.default)(ctx.req.__USER__)) {
            return next();
        }
        const { hash } = options;
        const hashFn = hash ? hash : exports.getCacheKey;
        const cacheKey = hashFn(ctx);
        // @ts-ignore
        const cached = exports.cache.get(cacheKey);
        if (cached && cached.html) {
            ctx.set('X-Cached-Response', 'HIT');
            ctx.response.type = cached.type;
            if (cached.lastModified) {
                ctx.response.lastModified = cached.lastModified;
            }
            if (cached.etag) {
                ctx.response.etag = cached.etag;
            }
            if (ctx.request.fresh) {
                ctx.response.status = 304;
                return;
            }
            ctx.response.body = cached.html;
            return;
        }
        ctx.set('X-Cached-Response', 'MISS');
        await next();
        const html = ctx.response.body;
        if (ctx.response.status !== 200 || !html)
            return;
        const data = {
            html,
            type: ctx.response.get('Content-Type') || null,
            lastModified: ctx.response.lastModified || null,
            etag: ctx.response.get('etag') || null,
        };
        if (ctx.request.fresh)
            ctx.response.status = 304;
        exports.cache.set(cacheKey, data, ttl);
    };
};
exports.outputCache = outputCache;
